<template>
  <div class="padded">
    <h2><i class="fa fa-users">&nbsp;</i><org-badge /> Dashboard<small v-if="org().shortName" class="text-info pull-right hidden-sm-and-down">{{org().name}}</small></h2>
    <hr />

    <div class="bg-bordered">
      <el-row type="flex" align="middle" justify="center" :gutter="12">

        <el-col align="center">
          <request-action button-size="small" type="RTA":row-data="{}" plain round />
        </el-col>

        <el-col align="center">
          <request-action button-size="small" type="RTS":row-data="{}" plain round />
        </el-col>

        <el-col align="center">
            <request-action button-size="small" type="RTU":row-data="{}"  plain round />
        </el-col>

        <el-col align="center">
          <request-action button-size="small" type="RTB" :row-data="{}"  plain round />
        </el-col>

        <el-col align="center">
          <ticket-action button-size="small" :row-data="{}" plain round />
        </el-col>

    </el-row>
    <el-row>
      <hr />
      <op-stats show-only-requests no-background  />
    </el-row>
    </div>


    <div class="dash-heading">Site Summary</div>

    <el-row align="middle" :gutter="12">

      <el-col :span="10">
        <sites-chart :show-legend="false" />
      </el-col>

      <el-col :span="6" align="left">
        <sites-stats-table />
      </el-col>

    </el-row>

    <el-row v-if="getStats().tickets > 0">
      <div class="dash-heading">Operations</div>

      <op-stats :show-requests="false"  />
    </el-row>

    <div class="dash-heading">Requests</div>

    <requests-report :summary="false" />

    <files-request-table  />

    <div class="dash-heading">Requests Calendar</div>
    <events-calendar category="requests" />

  </div>
</template>

<script>

import RequestAction from '@/components/actions/RequestAction'
import TicketAction from '@/components/actions/TicketAction'

import EventsCalendar from '@/components/atoms/EventsCalendar'
import FilesRequestTable from '@/components/tables/FilesRequestTable'

import SitesChart from '@/components/dashboard/charts/SitesChart'
import SitesStatsTable from '@/components/dashboard/sites/SitesStatsTable'

import RequestsReport from '@/components/dashboard/requests/RequestsReport'
import OpStats from '@/components/dashboard/OpStats'

export default {

  components: {
    RequestAction,
    TicketAction,
    EventsCalendar,
    FilesRequestTable,
    SitesChart,
    SitesStatsTable,
    RequestsReport,
    OpStats
  }
}

</script>



// WEBPACK FOOTER //
// TelcoView.vue?fd5fa47a